<template>
    <v-container fluid>
        <v-row class="align-center mb-2">
            <v-col cols="auto">
                <h2 class="text-h6">Progetti</h2>
            </v-col>
            <v-col cols="12" sm="4" md="3">
                <v-text-field v-model="ricerca" label="Cerca per codice o descrizione" density="compact"
                    variant="outlined" hide-details clearable prepend-inner-icon="mdi-magnify"
                    @update:model-value="ricercaCambiata" />
            </v-col>
            <v-spacer />
            <v-col v-if="isAdmin" cols="auto">
                <v-btn color="primary" prepend-icon="mdi-plus" @click="apriDialog(null)">Nuovo progetto</v-btn>
            </v-col>
        </v-row>

        <v-data-table :headers="headers" :items="lista" :items-per-page="15" density="comfortable">
            <template #[`item.codProgetto`]="{ item }">
                <a v-if="isAdmin" href="#" class="text-primary" @click.prevent="apriDialog(item)">{{ item.codProgetto
                    }}</a>
                <span v-else>{{ item.codProgetto }}</span>
            </template>
        </v-data-table>

        <v-dialog v-model="dialog" max-width="650" :fullscreen="isMobile">
            <v-card>
                <v-card-title>{{ form.id ? 'Modifica progetto' : 'Nuovo progetto' }}</v-card-title>
                <v-card-text>
                    <v-form ref="formRef">
                        <v-row>
                            <v-col cols="8">
                                <v-text-field v-model="form.codProgetto" label="Codice progetto"
                                    hint="Solo lettere, numeri, - e _, senza spazi" persistent-hint
                                    :rules="[v => !!v || 'Obbligatorio', v => /^[A-Za-z0-9_-]+$/.test(v || '') || 'Formato non valido']" />
                            </v-col>
                            <v-col cols="4">
                                <v-select v-model="form.pf" :items="['P', 'F']" label="P/F"
                                    :rules="[v => !!v || 'Obbligatorio']" />
                            </v-col>
                        </v-row>
                        <v-text-field v-model="form.descrizione" label="Descrizione" maxlength="200"
                            :rules="[v => !!v || 'Obbligatorio']" />
                        <v-row>
                            <v-col cols="8">
                                <v-select v-model="form.tipoSerramentoId" :items="tipologie" item-title="descrizione"
                                    item-value="id" label="Tipologia" :rules="[v => !!v || 'Obbligatorio']" />
                            </v-col>
                            <v-col cols="4">
                                <v-text-field v-model.number="form.numBattenti" type="number"
                                    label="Battenti default" :rules="[v => v > 0 || 'Obbligatorio']" />
                            </v-col>
                        </v-row>
                        <div class="text-caption text-medium-emphasis mb-1">Misure di riferimento (opzionali)</div>
                        <v-row dense>
                            <v-col cols="4">
                                <v-text-field v-model.number="form.l" type="number" step="0.1" label="L (mm)" />
                            </v-col>
                            <v-col cols="4">
                                <v-text-field v-model.number="form.h" type="number" step="0.1" label="H (mm)" />
                            </v-col>
                            <v-col cols="4">
                                <v-text-field v-model.number="form.spessore" type="number" step="0.1"
                                    label="Spessore (mm)" />
                            </v-col>
                        </v-row>
                        <v-row dense>
                            <v-col cols="6">
                                <v-text-field v-model.number="form.vanoVetro" type="number" label="Vano vetro (mm)"
                                    hint="Usato per cercare i nodi del calcolo 10077-2" persistent-hint />
                            </v-col>
                            <v-col cols="6">
                                <v-text-field v-model.number="form.progOrdinamento" type="number" label="Ordine" />
                            </v-col>
                        </v-row>

                        <div class="text-caption text-medium-emphasis font-weight-medium mt-2 mb-1">
                            Dati per la dichiarazione delle prestazioni
                        </div>
                        <v-row dense>
                            <v-col cols="12" sm="6">
                                <v-text-field v-model="form.modello" label="Modello" hint="Es. Serramento, Alzante"
                                    persistent-hint />
                            </v-col>
                            <v-col cols="12" sm="6">
                                <v-text-field v-model="form.profilo" label="Profilo" />
                            </v-col>
                        </v-row>
                        <v-row dense>
                            <v-col cols="12" sm="6">
                                <v-text-field v-model="form.laboratorio" label="Laboratorio di prova" />
                            </v-col>
                            <v-col cols="4" sm="2">
                                <v-text-field v-model.number="form.spessoreTelaio" type="number"
                                    label="Spess. telaio" />
                            </v-col>
                            <v-col cols="4" sm="2">
                                <v-text-field v-model.number="form.sezioneTelaio" type="number"
                                    label="Sez. telaio" />
                            </v-col>
                            <v-col cols="4" sm="2">
                                <v-text-field v-model.number="form.sezioneAnta" type="number" label="Sez. anta" />
                            </v-col>
                        </v-row>
                    </v-form>
                </v-card-text>
                <v-card-actions>
                    <v-spacer />
                    <v-btn v-if="form.id" variant="text" color="error" @click="elimina">Elimina</v-btn>
                    <v-spacer />
                    <v-btn variant="text" @click="dialog = false">Annulla</v-btn>
                    <v-btn color="primary" :loading="salvando" @click="salva">Salva</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-container>
</template>

<script>
export default {
    name: "ProgettiPage",

    data() {
        return {
            ricerca: "",
            timerRicerca: null,
            dialog: false,
            salvando: false,
            form: this.formVuoto(),
            headers: [
                { title: "Codice", key: "codProgetto" },
                { title: "Descrizione", key: "descrizione" },
                { title: "P/F", key: "pf" },
                { title: "Tipologia", key: "tipoSerramentoDescrizione" },
                { title: "Battenti", key: "numBattenti" },
            ],
        };
    },

    computed: {
        isMobile() {
            return this.$vuetify.display.smAndDown;
        },
        lista() {
            return this.$store.getters["progetti/lista"];
        },
        tipologie() {
            return this.$store.getters["tipologie/lista"];
        },
        isAdmin() {
            const ruolo = this.$store.getters["user/getRole"];
            return ruolo === "Admin" || ruolo === "SuperAdmin";
        },
    },

    mounted() {
        this.$store.dispatch("progetti/carica");
        this.$store.dispatch("tipologie/carica");
    },

    methods: {
        formVuoto() {
            return {
                id: null, codProgetto: "", descrizione: "", pf: "F", tipoSerramentoId: null,
                numBattenti: 1, l: null, h: null, spessore: null, vanoVetro: null, progOrdinamento: 0,
                modello: "", profilo: "", laboratorio: "", spessoreTelaio: null, sezioneTelaio: null, sezioneAnta: null,
            };
        },

        // v-model.number lascia "" nei campi svuotati: per il backend i numeri opzionali devono essere null.
        numeroOpzionale(v) {
            return v === "" || v === null || v === undefined ? null : Number(v);
        },

        ricercaCambiata() {
            clearTimeout(this.timerRicerca);
            this.timerRicerca = setTimeout(() => {
                this.$store.dispatch("progetti/carica", this.ricerca);
            }, 300);
        },

        apriDialog(item) {
            if (item && !this.isAdmin) return;
            this.form = item
                ? {
                    id: item.id, codProgetto: item.codProgetto, descrizione: item.descrizione, pf: item.pf,
                    tipoSerramentoId: item.tipoSerramentoId, numBattenti: item.numBattenti,
                    l: item.l, h: item.h, spessore: item.spessore, vanoVetro: item.vanoVetro,
                    progOrdinamento: item.progOrdinamento,
                    modello: item.modello || "", profilo: item.profilo || "", laboratorio: item.laboratorio || "",
                    spessoreTelaio: item.spessoreTelaio, sezioneTelaio: item.sezioneTelaio, sezioneAnta: item.sezioneAnta,
                }
                : this.formVuoto();
            this.dialog = true;
        },

        async salva() {
            const { valid } = await this.$refs.formRef.validate();
            if (!valid) return;
            this.salvando = true;
            try {
                const { id, ...resto } = this.form;
                const dati = {
                    ...resto,
                    l: this.numeroOpzionale(resto.l),
                    h: this.numeroOpzionale(resto.h),
                    spessore: this.numeroOpzionale(resto.spessore),
                    vanoVetro: this.numeroOpzionale(resto.vanoVetro),
                    spessoreTelaio: this.numeroOpzionale(resto.spessoreTelaio),
                    sezioneTelaio: this.numeroOpzionale(resto.sezioneTelaio),
                    sezioneAnta: this.numeroOpzionale(resto.sezioneAnta),
                };
                if (id) {
                    await this.$store.dispatch("progetti/aggiorna", { id, dati });
                } else {
                    await this.$store.dispatch("progetti/crea", dati);
                }
                this.dialog = false;
            } catch (error) {
                console.log(error);
            }
            this.salvando = false;
        },

        async elimina() {
            try {
                await this.$store.dispatch("progetti/elimina", this.form.id);
                this.dialog = false;
            } catch (error) {
                console.log(error);
            }
        },
    },
};
</script>
